import Select from '@components/Select'
import Button from '@components/Button'
import { CardSection } from '@components/CardSection'
import { makePurchasePendingSelector } from 'basket/selectors'
import {
    disabledCardsSelector,
    lastBookingBasketItemSelector,
    parkingModeSelector,
    selectedVehicleSelector,
    vehiclesSelector,
} from '@booking/selectors'
import { selectVehicle, enableCard } from '@booking/actions'
import { CARDS } from '@booking/reducers'

const VehicleSection = ({
    vehicles,
    selectedVehicles,
    rate,
    onAddAnotherBooking,
    makePurchasePending,
    areRatesPending,
    disabled,
    isEventFlow,
    updateValidation,
    currentItemIndex,
    enableCard,
    selectVehicle,
}) => {
    const isMultipleVehicle = rate && rate.isMultipleVehicle
    const numberOfVehicles = rate && rate.numberOfVehicles

    React.useEffect(() => {
        updateValidation({
            selectedVehiclesError: false,
            isSameTicketInBasketError: false,
        })

        if (vehicles && selectedVehicles.length === 0 && vehicles.length > 0) selectVehicle([vehicles[0]])
        if (vehicles && selectedVehicles.length > 1 && !isMultipleVehicle) selectVehicle([vehicles[0]])
    }, [vehicles, currentItemIndex, isMultipleVehicle, rate])

    React.useEffect(() => {
        updateValidation({
            selectedVehiclesError: false,
        })

        if (selectedVehicles && selectedVehicles.length > 0) enableCard([CARDS.PAY_FOR_PARKING])
    }, [selectedVehicles, rate])

    React.useEffect(
        () => () => {
            selectVehicle()
        },
        []
    )

    return (
        <CardSection disabled={disabled} className="select" title={<T>booking.confirm.vehicle</T>}>
            <b>
                <T>{isMultipleVehicle ? 'booking.select.vehicles.label' : 'booking.select.vehicle.label'}</T>
            </b>
            <div className="row justify-content-between mt-3">
                <div className="col-sm-5">
                    <div className="booking__select">
                        <Select
                            options={
                                !!numberOfVehicles && selectedVehicles.length >= numberOfVehicles
                                    ? selectedVehicles
                                    : vehicles
                            }
                            value={selectedVehicles}
                            getOptionValue={option => option.id}
                            getOptionLabel={option => `${option.make} ${option.model} ${option.tag}`}
                            onChange={selectVehicle}
                            isMulti={isMultipleVehicle}
                            isDisabled={makePurchasePending === true}
                            delimiter=","
                        />

                        <Button
                            className="ml-auto booking__select__button"
                            size="small"
                            btnStyle="link"
                            iconLeft="plus-round"
                            href="dashboard/vehicles">
                            <T>dashboard.vehicles.add.label</T>
                        </Button>
                    </div>
                </div>
                {!isEventFlow && (
                    <div className="col-sm-6 col-xs-12 d-flex flex-column align-items-end">
                        <Button
                            size="large"
                            block
                            onClick={onAddAnotherBooking}
                            btnStyle="outline"
                            disabled={areRatesPending || makePurchasePending === true}>
                            <T>booking.btn.add.another.booking</T>
                        </Button>
                    </div>
                )}
            </div>
        </CardSection>
    )
}

export default compose(
    connect(
        createStructuredSelector({
            makePurchasePending: makePurchasePendingSelector,
            vehicles: vehiclesSelector,
            selectedVehicles: selectedVehicleSelector,
            lastBookingBasketItem: lastBookingBasketItemSelector,
            disabledCards: disabledCardsSelector,
            parkingMode: parkingModeSelector,
        }),
        {
            selectVehicle,
            enableCard,
        }
    )
)(VehicleSection)
